import Entity from './entity'
export default class Inairdata extends Entity<number>{
   
}